import { useState } from 'react';

export type RenderFunction = () => void;
export const useRender = () : RenderFunction => {
  const [value, setValue] = useState(false);
  return () => {
    setValue(!value);
  };
};
